module.exports = __webpack_public_path__ + "img/yellow-circle-table-3.a40a7e71.png";